import React, { FC, useState, useEffect, useRef } from 'react';
import classNames from 'classnames/bind';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import { BlogPostCard } from 'components/BlogPosts/BlogPosts.types';
import { BlogPost } from 'components/BlogPosts/BlogPost';
import styles from 'components/BlogPosts/BlogPosts.module.scss';

const cn = classNames.bind(styles);

interface BlogPostsProps {
  posts: BlogPostCard[];
}

const BlogPosts: FC<BlogPostsProps> = ({ posts }) => {
  const [paginationEl, setPaginationEl] = useState<HTMLDivElement | null>(null);
  const swiperRef = useRef<any>(null);
  const swiperPaginationRef = useRef<HTMLDivElement>(null);

  const swiperSlides = posts.map((post) => {
    return (
      <SwiperSlide
        key={post.id}
        className={cn('swiper__slide')}
      >
        <BlogPost
          id={post.id}
          url={post.url}
          image={post.image}
          tag={post.tag}
          date={post.date}
          title={post.title}
        />
      </SwiperSlide>
    );
  });

  useEffect(() => {
    const handleResize = () => {
      if (swiperRef.current) {
        swiperRef.current.update();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (swiperPaginationRef.current) {
      setPaginationEl(swiperPaginationRef.current);
    }
  }, []);

  return (
    <div className={cn('blog-posts')}>
      {paginationEl &&
        <Swiper
          className={cn('swiper')}
          slidesPerView={1}
          spaceBetween={24}
          modules={[Pagination]}
          pagination={{
            el: paginationEl,
            clickable: true,
          }}
          onSwiper={(swiperInstance) => {
            swiperRef.current = swiperInstance;
          }}
          breakpoints={{
            769: {
              slidesPerView: 2,
            },
            1025: {
              slidesPerView: 3,
            }
          }}
          onBreakpoint={(swiper) => {
            swiper.pagination.update();
          }}
        >
          {swiperSlides}
        </Swiper>}
      <div className={cn('swiper-pagination')} ref={swiperPaginationRef} />
    </div>
  );
};

export { BlogPosts };
